import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "../Context";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
// import { func } from "three/examples/jsm/nodes/Nodes.js";
import { FieldValue, addDoc, collection, deleteDoc, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase";
import back from "../Assets/back (2).png"
import * as XLSX from 'xlsx'
import download from "../Assets/download.png";
import trash from "../Assets/trash.png"
import contract from "../Assets/contract.png"
import confirm from "../Assets/confirm.png"
import modify from "../Assets/edit.png"
import down from "../Assets/down.png"

export default function AmmortizationSchedule() {
    const navigate = useNavigate()
    const [paymentMap, setPaymentMap] = useState(new Map());
    const { user, loading, setLoading, leases, setLeases } = useUser();
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const id = url.searchParams.get('id');
    const [allowModify, setAllowModify] = useState(false)
    // const [lease,setLease]=useState();
    // const lease = ;
    const [ammortizationSchedule, setAmmortizationSchedule] = useState()
    const [leaseDetails, setLeaseDetails] = useState(leases[id])
    // console.log(leases[id])

    async function fetchLeaseData(lease) {
        setLoading(true);
        try {
            const ammortizationDoc = await getDoc(doc(db, 'ammortization', lease))
            if (ammortizationDoc.exists()) {
                // console.log(ammortizationDoc.data())
                setAmmortizationSchedule(ammortizationDoc.data().data)
            }
            // const leaseDoc = await getDoc(doc(db, "lease", lease))
            // if (leaseDoc) {
            //     setLeaseDetails(leaseDoc.data());
            // }
        } catch (error) {
            console.log("Error in getting data");
        }
        setLoading(false)
    }

    useEffect(() => {
        if (leases) {
            setLeaseDetails(leases[id]);
        }
    }, [leases])

    useEffect(() => {
        if (user) {
            // setLease()
            fetchLeaseData(user.leaseList[id]);
        }
    }, [user])

    const handleIncreaseDecimalPlaces = () => {
        if (decimalPlaces < 6) {
            setDecimalPlaces(prevValue => prevValue + 1);
        } else {
            toast.warn("Decimal places cannot exceed 6");
        }
    };

    const handleDecreaseDecimalPlaces = () => {
        if (decimalPlaces > 0) {
            setDecimalPlaces(prevValue => prevValue - 1);
        } else {
            toast.warn("Decimal places cannot be less than 0");
        }
    };

    const handlePaymentChange = (index, value) => {
        const newPaymentMap = new Map(paymentMap);
        let val = parseFloat(value.split(' ')[1]);
        if (isNaN(val)) {
            val = 0;
        }
        // console.log(val);
        // console.log(index);
        newPaymentMap.set(index, parseFloat(val));
        setPaymentMap(newPaymentMap);
    };
    // console.log(paymentMap)

    const calculateMonth = (startDate, index) => {
        const date = new Date(startDate);
        date.setMonth(date.getMonth() + index - 1);
        // console.log(date);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // console.log(ammortizationSchedule)
    async function modifyLease() {
        setLoading(true)
        let temp = [];
        console.log(ammortizationSchedule)
        // let rent1 = parseFloat(leaseDetails.rent);
        let rent2;
        // let escalation = parseFloat(leaseDetails.escalationRate);
        // let leaseLiablility = 0;
        // for (let i = 1; i <= ammortizationSchedule.length; i++) {
        // // for (let i = 1; i <= leaseDetails.period; i++) {
        //     if (i % 12 === 1 && i !== 1) {
        //         rent1 += rent1 * escalation;
        //     }
        //     let discountFactor;
        //     if (leaseDetails.paymentType === 'arrear') {
        //         discountFactor = 1 / Math.pow((1 + (leaseDetails.interest / 12)), i);
        //     }
        //     else {
        //         discountFactor = 1 / Math.pow((1 + (leaseDetails.interest / 12)), i - 1);
        //     }
        //     leaseLiablility += discountFactor * rent1;
        //     // console.log(discountFactor, " * ", rent1, " = ",leaseLiablility)
        // }
        // let openingLeaseLiability = leaseLiablility;
        let openingLeaseLiability=leaseDetails.openingLeaseLiability
        let monthlyInterest = ammortizationSchedule;
        let ClosingROU = 0;
        // let ROUAsset;
        // let pvOfSD;
        // let closingPVSD = 0;
        // let interestIncome = 0;
        // let ppRent = 0;
        // let openingROUAsset = 0
        for (let i = 1; i <= ammortizationSchedule.length; i++) {
        // for (let i = 1; i <= leaseDetails.period; i++) {
            // if (i % 12 === 1 && i !== 1) {
            //     rent2 += rent2 * escalation;
            // }
            // console.log(ammortizationSchedule);
            // console.log(i-1)
            rent2 = ammortizationSchedule[i - 1].rent
            if (paymentMap.has(i - 1)) {
                rent2 = paymentMap.get(i - 1);
            }
            // rent2=paymentMap.get(i-1) || paymentMap.get(i-1) >=0?paymentMap.get(i-1):rent2
            // console.log("Rent for period: ",i, " is : ",parseFloat(rent2));
            let discountFactor=ammortizationSchedule[i-1].discountFactor;
            // if (leaseDetails.paymentType === 'arrear') {
            //     discountFactor = 1 / Math.pow((1 + (leaseDetails.interest / 12)), i);
            // }
            // else {
            //     discountFactor = 1 / Math.pow((1 + (leaseDetails.interest / 12)), i - 1);
            // }
            // if (!closingPVSD) {
            //     pvOfSD = leaseDetails.securityDeposit / Math.pow(1 + (leaseDetails.interest / 12), leaseDetails.period - 1);
            // }
            // else {
            //     pvOfSD = closingPVSD;
            // }
            // console.log(pvOfSD)
            if (i === 1 && leaseDetails.paymentType === 'advance') {
                monthlyInterest = 0;
            }
            else {
                monthlyInterest = openingLeaseLiability * (leaseDetails.interest / 12);
            }

            let closingBalance = openingLeaseLiability + monthlyInterest - rent2;
            // ppRent = ppRent === 0 ? leaseDetails.securityDeposit - pvOfSD : ppRent;
            // if (ClosingROU) {
            //     ROUAsset = ClosingROU;
            // }
            // else {
            //     ROUAsset = ppRent + leaseLiablility;
            //     openingROUAsset = ROUAsset;
            // }
            // if (closingPVSD) {
            //     interestIncome = pvOfSD * (leaseDetails.interest / 12);
            // }
            // closingPVSD = pvOfSD + interestIncome;
            // let depreciation = (ppRent + leaseLiablility) / leaseDetails.period;
            // ClosingROU = ROUAsset - depreciation;
            // console.log(temp);
            // console.log()
            temp.push({
                period: i,
                discountFactor: discountFactor,
                month: calculateMonth(leaseDetails.startDate, i),
                rent: ammortizationSchedule[i - 1].rent,
                payment: rent2,
                rentIntoDisc: (discountFactor * ammortizationSchedule[i - 1].rent),
                openingLeaseLiability: openingLeaseLiability,
                monthlyInterest: monthlyInterest,
                closingBalance: closingBalance,
                pvOfSD: ammortizationSchedule[i-1].pvOfSD,
                ROUAsset: ammortizationSchedule[i-1].ROUAsset,
                depreciation: ammortizationSchedule[i-1].depreciation,
                closingRou: ClosingROU,
                interestIncome: ammortizationSchedule[i-1].interestIncome,
                closingPvofSD: ammortizationSchedule[i-1].closingPvofSD
            })
            openingLeaseLiability = closingBalance;
            // ROUAsset = ClosingROU;
            // pvOfSD = closingPVSD;
        }
        setAmmortizationSchedule(temp)
        // console.log(user.leaseList[id])
        try {
            await setDoc(doc(db, "ammortization", user.leaseList[id]), {
                data: temp
            })
        } catch (error) {
            toast.error("Error in creating new lease.")
            console.error("Error in creating new lease", error);
        }
        toast.success("Modifications made.");
        setAllowModify(false);
        setLoading(false)
        setLeaseActions(!leaseActions)
    }
    const leaseHeading = ["Period", "Month", "PV Factor", "Lease Expense", "Payment", "PV of Lease Expense", "Opening Lease Liability Balance", " Finance Cost", " Closing Lease Liability Balance", " Opening SD Balance", " ROU Asset Opening Balance", " Depreciation", " ROU Asset Closing Balance", " Interest Income", " Closing SD Balance"];
    const [decimalPlaces, setDecimalPlaces] = useState(2)

    function downloadExcel() {
        setLoading(true)
        const workbook = XLSX.utils.book_new();
        const masterSheetData = [leaseHeading];
        ammortizationSchedule.forEach((row) => {
            masterSheetData.push([
                row.period,
                row.month,
                row.discountFactor,
                row.rent,
                row.payment,
                row.rentIntoDisc,
                row.openingLeaseLiability,
                row.monthlyInterest,
                row.closingBalance,
                row.pvOfSD,
                row.ROUAsset,
                row.depreciation,
                row.closingRou,
                row.interestIncome,
                row.closingPvofSD,
            ])
        });
        const masterSheet = XLSX.utils.aoa_to_sheet(masterSheetData);
        XLSX.utils.book_append_sheet(workbook, masterSheet, 'Ammortization Schedule');
        XLSX.writeFile(workbook, `Lease ${parseInt(id) + 1}.xlsx`);
        setLoading(false);
        setLeaseActions(!leaseActions)
    }

    async function deleteLease() {
        try {
            const leaseId = user.leaseList[id]
            // console.log(leaseId);
            // let tempLease=user.leaseList.filter(item=>item!==leaseId);
            let tempLease = user.leaseList
            tempLease.splice(id, 1);
            // console.log(user.leaseList.length)
            let tempLeaseList = leases
            tempLeaseList.splice(id, 1);

            setLeases(tempLeaseList)

            updateDoc(doc(db, 'lessee', user.uid), {
                leaseList: tempLease
            })
            deleteDoc(doc(db, 'lease', leaseId))

            deleteDoc(doc(db, 'ammortization', leaseId))

            toast.success("Lease deleted successfully.")
            setDeleteModal(false)
            setLeaseActions(!leaseActions)
            navigate('/dashboard')
        }
        catch (error) {
            toast.error("Error in deleting lease.")
        }
    }

    const [deleteModal, setDeleteModal] = useState(false);
    const [terminationModal, setTerminationModal] = useState(false)
    const [terminationMonth, setTerminationMonth] = useState()

    async function terminateLease() {
        try {
            setLoading(true);
            if (!terminationMonth || terminationMonth > ammortizationSchedule.length) {
                toast.warn("Please  enter a valid month number")
                setLoading(false);
                return;
            }
            let temp = ammortizationSchedule.splice(0, terminationMonth)
            // console.log(temp);
            await updateDoc(doc(db, 'ammortization', user.leaseList[id]), {
                data: temp
            })
            // console.log(tempLeaseList);
            await updateDoc(doc(db, 'lease', user.leaseList[id]), {
                earlyTermination: true
            })
            setAmmortizationSchedule(temp)
            let tempLeaseList = [...leases];
            tempLeaseList[id].earlyTermination = true;
            console.log(tempLeaseList);
            setLeases(tempLeaseList);
            setTerminationMonth();
            setLoading(false);
            setTerminationModal(false);
        }
        catch (err) {
            console.log(err);
        }
        setLeaseActions(!leaseActions)

    }

    const [leaseActions, setLeaseActions] = useState(false)

    return (<>
        {!user || loading ? <Loading /> :
            <>
                <div className="flex justify-between items-center px-16 py-6">
                    <div onClick={() => { navigate(-1) }} className="  w-fit group gap-1 cursor-pointer z-30 text-gray-600 flex items-center text-xl font-light">
                        <img className="h-5" src={back} alt="back" />back
                    </div>
                    <div className="flex flex-col items-center">
                        <button onClick={() => setLeaseActions(!leaseActions)} className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white min-w-52">
                            Lease Actions
                            {leaseActions ?
                                <img className="transition-all w-5 -pt-1 group-hover:invert rotate-180" src={down} alt="add" />
                                :
                                <img className="transition-all w-5 pt-1 group-hover:invert" src={down} alt="add" />
                            }
                        </button>
                        {
                            leaseActions &&
                            <div className="flex flex-col relative w-0 h-0 gap-2 items-center">
                                <button></button>
                                <button onClick={() => { setTerminationModal(true) }} className="shadow-sm justify-self-end group rounded px-4 py-2 bg-white flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-red-500 hover:text-white min-w-52">Terminate Lease
                                    <img className="h-6 group-hover:invert" src={contract} alt="contract" />
                                </button>
                                <button onClick={() => { setDeleteModal(true) }} className="shadow-sm justify-self-end group rounded px-4 py-2 bg-white flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-red-500 hover:text-white min-w-52">Delete Lease
                                    <img className="h-5 group-hover:invert" src={trash} alt="delete" />
                                </button>
                                <button onClick={() => downloadExcel()} className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white bg-white min-w-52">
                                    Download excel
                                    <img className="w-4 group-hover:invert" src={download} alt="add" />
                                </button>
                                {allowModify ?
                                    <button className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white bg-white min-w-52" onClick={() => { modifyLease() }} >
                                        Save changes
                                        <img className="w-5 group-hover:invert" src={confirm} alt="add" />
                                    </button>
                                    :
                                    <button className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white bg-white min-w-52" onClick={() => { setAllowModify(true) }} >
                                        Modify Payment
                                        <img className="w-4 group-hover:invert" src={modify} alt="add" />
                                    </button>
                                }
                            </div>
                        }
                    </div>
                    {/* <div className="flex items-center gap-6">
                        <button onClick={() => { setTerminationModal(true) }} className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-red-500 hover:text-white">Terminate Lease
                            <img className="h-6 group-hover:invert" src={contract} alt="contract" />
                        </button>
                        <button onClick={() => { setDeleteModal(true) }} className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-red-500 hover:text-white">Delete Lease
                            <img className="h-5 group-hover:invert" src={trash} alt="delete" />
                        </button>
                    </div> */}
                </div>
                {
                    terminationModal &&
                    <div className="fixed top-0 left-0 bg-[#ffffffdd] w-screen h-screen z-30">
                        <div className="fixed rounded-xl flex flex-col gap-6 bg-white border w-1/2 shadow-lg text-gray-600 p-4 px-6 top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%]">
                            <h2 className="text-xl">
                                Please specify the period after which you want to terminate this lease. For instance, if you want the lease to end after period 15, enter "15". This means the lease will be terminated starting from period 16.
                            </h2>
                            <input className="border py-2 px-4 rounded-lg outline-none hover:shadow-md text-lg focus:shadow-md duration-200 transition-all" type="number" value={terminationMonth} onChange={(e) => { setTerminationMonth(e.target.value) }} placeholder="4" />
                            <div className="flex justify-center gap-12">
                                <button onClick={() => { setTerminationModal(false) }} className="shadow-sm group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white" >Cancel</button>
                                <button onClick={() => { terminateLease() }} className="shadow-sm rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-red-500 hover:text-white border" >Proceed</button>
                            </div>
                        </div>
                    </div>
                }
                {
                    deleteModal &&
                    <div className="fixed top-0 left-0 bg-[#ffffffdd] w-screen h-screen z-30 backdrop-blur-sm">
                        <div className="fixed rounded-xl flex flex-col gap-4 bg-white border w-1/3 shadow-lg text-red-600 p-4 px-6 top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%]">
                            <h2 className="text-xl">
                                Once deleted, this lease cannot be recovered. Are you certain you want to proceed with the deletion?
                            </h2>
                            <div className="flex justify-center gap-12">
                                <button onClick={() => { setDeleteModal(false) }} className="shadow-sm group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white" >Cancel</button>
                                <button onClick={() => { deleteLease() }} className="shadow-sm rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-red-500 hover:text-white border" >Proceed</button>
                            </div>
                        </div>
                    </div>
                }
                {leaseDetails && ammortizationSchedule &&
                    <section className="p-12 py-0 bg-white  w-screen h-auto flex flex-col">
                        {/* <h2 className="text-2xl py-4"> </h2> */}
                        <div className="ml-6 text-lg grid  grid-cols-3 w-full grid-flow-dense gap-y-2">
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Lessor Name: </h2>
                                <p className="text-gray-600">{leaseDetails.lesseeName}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Location: </h2>
                                <p className="text-gray-600">{leaseDetails.location}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >City: </h2>
                                <p className="text-gray-600">{leaseDetails.city}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Rent: </h2>
                                {/* {console.log(leaseDetails)} */}
                                <p className="text-gray-600">₹ {leaseDetails.rent.toFixed(4)}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Escalation Rate: </h2>
                                <p className="text-gray-600">{(leaseDetails.escalationRate * 100).toFixed(4)}%</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Escalation Period: </h2>
                                <p className="text-gray-600">{leaseDetails.escalationPeriod}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Interest: </h2>
                                <p className="text-gray-600">{(leaseDetails.interest * 100).toFixed(4)}%</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Start Date: </h2>
                                <p className="text-gray-600">{leaseDetails.startDate}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >End Date: </h2>
                                <p className="text-gray-600">{leaseDetails.endDate}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Security Deposit: </h2>
                                <p className="text-gray-600">₹ {leaseDetails.securityDeposit.toFixed(4)}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Agree Date: </h2>
                                <p className="text-gray-600">{leaseDetails.agreeDate}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Posession Date: </h2>
                                <p className="text-gray-600">{leaseDetails.possesDate}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Payment in: </h2>
                                <p className="text-gray-600 capitalize">{leaseDetails.paymentType}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Asset type: </h2>
                                {leaseDetails.type === 'property' && <p className="text-gray-600">Property /  Real Estate</p>}
                                {leaseDetails.type === 'vehicle' && <p className="text-gray-600">Vechicle</p>}
                                {leaseDetails.type === 'equipment' && <p className="text-gray-600">Equipment and Machinery</p>}
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Opening ROU Asset: </h2>
                                <p className="text-gray-600">₹ {leaseDetails.openingROUAsset?.toFixed(4)}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Opening Lease Liability: </h2>
                                <p className="text-gray-600">₹ {leaseDetails.openingLeaseLiability?.toFixed(4)}</p>
                            </div>
                            <div className="flex gap-2">
                                <h2 className="text-blue-500" >Prepaid Rent: </h2>
                                <p className="text-gray-600">₹ {leaseDetails.prepaidRent?.toFixed(4)}</p>
                            </div>
                        </div>

                        <div className="flex justify-between items-center  pr-6">
                            <div className="py-4 pl-6 flex items-center gap-3 text-lg text-gray-600">
                                Round off to
                                <div className="border rounded-md overflow-hidden">
                                    <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all hover:bg-sky-600 text-lg" onClick={handleDecreaseDecimalPlaces}>-</button>
                                    <input className="h-full w-10 outline-none text-center" type="number" value={decimalPlaces} readOnly />
                                    <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all hover:bg-sky-600 text-lg" onClick={handleIncreaseDecimalPlaces}>+</button>
                                </div>
                                decimal places
                            </div>
                            {/* <div className="flex gap-6 ">
                                <button onClick={() => downloadExcel()} className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white">
                                    Download excel
                                    <img className="w-4 group-hover:invert" src={download} alt="add" />
                                </button>
                                {allowModify ?
                                    <button className="px-4 rounded text-lg h-fit py-2 transition-all duration-200 hover:bg-sky-500 hover:text-white border hover:shadow-lg" onClick={() => { modifyLease() }} >
                                        Save changes
                                    </button>
                                    :
                                    <button className="px-4 rounded text-lg h-fit py-2 transition-all duration-200 hover:bg-sky-500 hover:text-white border hover:shadow-lg" onClick={() => { setAllowModify(true) }} >
                                        Modify Payment
                                    </button>
                                }
                            </div> */}
                        </div>
                        <div className="scrollbox mb-12 mx-6 ">
                            <div className="flex w-full justify-between sticky top-0">
                                {leaseHeading.map((heading, index) => {
                                    return (
                                        <div className={`p-2 px-3 capitalize border bg-sky-500 text-white invert-1 ${heading === 'Period' && 'min-w-28'} ${heading === 'Month' && 'min-w-40'} ${heading === 'PV Factor' && 'min-w-40'} ${(heading !== 'PV Factor' && heading !== 'Month' && heading !== 'Period') && 'min-w-60'}`} key={index}>
                                            {heading}
                                        </div>
                                    )
                                }
                                )
                                }
                            </div>
                            <div className="w-full pr-12">
                                {ammortizationSchedule.map((lease, index) => {
                                    // console.log(lease.rent)
                                    return (
                                        <div className="flex w-full justify-between" key={index}>
                                            <div className="min-w-28 border p-2 px-3">{lease.period}</div>
                                            <div className="min-w-40 border p-2 px-3">{lease.month}</div>
                                            <div className="min-w-40 border p-2 px-3">{lease.discountFactor.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.rent.toFixed(decimalPlaces)}</div>
                                            <input disabled={!allowModify} onChange={(e) => { handlePaymentChange(index, e.target.value) }} className={`min-w-60 outline-none border p-2 focus:border-gray-400 transition-all duration-200 px-3 ${!allowModify ? 'bg-gray-200 border-gray-300' : ''} `} value={"₹ " + (paymentMap.get(index) || paymentMap.get(index) >= 0 ? paymentMap.get(index).toFixed(decimalPlaces) : (lease.rent).toFixed(decimalPlaces))} />
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.rentIntoDisc.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.openingLeaseLiability.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.monthlyInterest.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {Math.abs(lease.closingBalance.toFixed(decimalPlaces))}</div>
                                            {/* <div className="min-w-60 border p-2 px-3">₹ {lease.closingBalance.toFixed(decimalPlaces)}</div> */}
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.pvOfSD.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.ROUAsset.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.depreciation.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.closingRou.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.interestIncome.toFixed(decimalPlaces)}</div>
                                            <div className="min-w-60 border p-2 px-3">₹ {lease.closingPvofSD?.toFixed(decimalPlaces)}</div>
                                            {/* <div className="min-w-40 border p-2 px-3">₹ {lease.prepaidRent.toFixed(decimalPlaces)}</div> */}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>}
            </>
        }
    </>
    )
}